<section class="t-pad-bottom">
  <dr-profile-filters
    id="profileSearch"
    class="l-block t-row--med"
    (onSearch)="getProfilesBySearch($event)"
    (onCreate)="onCreateClicked()"
  ></dr-profile-filters>

  <loader *ngIf="loading"></loader>

  <div
    *ngIf="data && !data.length && !loading"
    role="alert"
    class="c-alert t-alert-info"
  >
    {{ "translate.alert.noResults" | translate }}
  </div>

  <dr-profile-list
    [data]="data"
    [totalRecords]="searchMetaData.totalRecords"
    [numberOfRows]="numberOfRows"
    (requestUpdate)="loadDataOnPagination($event)"
    (onEdit)="edit($event)"
  ></dr-profile-list>
</section>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="editProfileDisplay = false"
  [isOpen]="editProfileDisplay"
>
  <edit-dr-profile-wizard
    *ngIf="editProfileDisplay"
    [data]="editRow"
    (onCancel)="editProfileDisplay = false"
    (onSave)="onSave()"
  ></edit-dr-profile-wizard>
</modal-popup>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="createProfileDisplay = false"
  [isOpen]="createProfileDisplay"
>
  <create-dr-profile
    *ngIf="createProfileDisplay"
    (onClose)="onCreateProfileClosed($event)"
  ></create-dr-profile>
</modal-popup>
